import { ChatSocketRepository } from "../repositories/ChatSocketRepository";

export class EmitTempMessage {
	constructor(private repository: ChatSocketRepository) {}

	execute(messageId: string): Promise<void> {
		return this.repository.emitTempMessage(messageId);
	}
}
